module.exports = __webpack_public_path__ + "static/img/ting.38a41e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ting.png
// module id = E3iI
// module chunks = 1